const variationBasePath = "/variations";

const VariationConst = {
    basePath: variationBasePath,
};

export default VariationConst;
